// **********************************************************
// Product List Slider
// **********************************************************

const productListSlider = document.querySelectorAll('[data-slider="product-list-slider"]');

const productListSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 8,
  watchOverflow: true,
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1023: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
    1240: {
      slidesPerView: 5,
      spaceBetween: 25,
    },
  },
};

productListSlider.forEach((el) => new Swiper(el, productListSliderOptions));

// import ResponsiveAutoHeight from 'responsive-auto-height';
const matchHeightElem = document.querySelectorAll('[data-match-height]');
if (matchHeightElem.length > 0) {
  // eslint-disable-next-line no-new
  new ResponsiveAutoHeight('[data-match-height]');
}
